(function () {
    'use strict';
    var m = angular.module('policy');
    m.directive('select2', ["$timeout", "commonDao", "regexUtility", "$q", function ($timeout, commonDao, regexUtility, $q) {
        function defaultCreateSearchChoice(term, data) {
            if ($(data).filter(function () {
                    return this.text.localeCompare(term) === 0;
                }).length === 0) {
                return {
                    id: term,
                    text: term
                };
            }
        }
        function filterText(text) {
            var filteredText = '';
            if (text) {
                filteredText = text.trim();
                filteredText = filteredText.replace(/\./g, '');
            }
            return filteredText;
        }
        return {
            restrict: 'A',
            replace: false,
            scope: {
                model: '=select2',
                variants: '=?',
                settings: '=?',
                lookupParams: '=?',
                selectDisabled: '=?',
                focusOnLoad: '=?'
            },
            link: function ($scope, element, attrs) {
                var initialized = false;
                $scope.settings = $scope.settings || {};
                var multiple = false;
                var recordsPerPage = 10;
                var currentElement = [];
                var requiredFocus = false;
                function select2Data() {
                    var selectData = element.select2('data');
                    if (_(selectData).isArray()) {
                        return _(selectData).map(function (d) {
                            return d.id;
                        });
                    } else if (selectData) {
                        return selectData.id;
                    } else {
                        return undefined;
                    }
                }
                element.on('change', function (data) {
                    $timeout(function () {
                        var inputData = select2Data();
                        if ($scope.settings.filterString) {
                            if (_(inputData).isArray()) {
                                inputData = _(inputData).map(function (data) {
                                    return filterText(data);
                                });
                            } else if (inputData) {
                                inputData = filterText(inputData);
                            }
                            requiredFocus = true;
                        }
                        // validation ip address and subnet
                        if ($scope.settings.validation && $scope.settings.validationType === 'ip' && !$scope.settings.validationOnTyping) {
                            if (inputData && inputData.length) {
                                var lastData = inputData[inputData.length - 1];
                                if (!regexUtility.utilities.validationIPandSubnet(lastData) && lastData.indexOf('Not valid IP') === -1) {
                                    inputData[inputData.length - 1] = lastData + ' (Not valid IP)';
                                }
                            }
                            $scope.model = inputData;
                            $timeout(function () {
                                element.parent($scope.settings.parentElement).find('.select2-search-choice div').each(function (key, $ele) {
                                    var modelData = angular.element($ele).text();
                                    if (modelData.indexOf('Not valid IP') !== -1) {
                                        angular.element($ele).parent('.select2-search-choice').css({
                                            'border-color': '#b73920',
                                            'background': '#cc4125',
                                            'color': 'white'
                                        });
                                    }
                                });
                            });
                        } else {
                            $scope.model = inputData;
                        }
                    });
                });
                if ($scope.settings.triggerOnKeySpace) {
                    angular.element(document).on('keydown', element, function (event) {
                        if (event.which === 32 && element.select2('isFocused') && _(select2Data()).isArray()) {
                            currentElement = $(event.target);
                            var inputData = select2Data();
                            inputData = _(inputData).map(function (data) {
                                return filterText(data);
                            });
                            $scope.model = inputData;
                            $timeout(function () {
                                $scope.model.push(filterText(currentElement.val()));
                                requiredFocus = true;
                            });
                        }
                    });
                }
                /*
                validationOnTyping is required the following settings params
                - example
                errTipContent: 'Not valid IP',
                parentElement: '.form-inline',
                successTipContent: 'Valid IP (Press Space key to complete.)',
                validation: true,
                validationType: 'ip',
                validationOnTyping: true
             */
                if ($scope.settings.validationOnTyping) {
                    // add warning tooltip
                    var $parentFormControl = element.parent($scope.settings.parentElement);
                    $parentFormControl.addClass('custom-tip');
                    $parentFormControl.append('<span class="custom-tip-text err-tip">' + $scope.settings.errTipContent + '</span>' + '<span class="custom-tip-text success-tip">' + $scope.settings.successTipContent + '</span>');
                    var changeBoxStyle = function (borderColor, isError, isSuccess) {
                        /*
                        normal color: #555555, border-color: #cccccc,
                        error color: #ffffff, border-color: #cc4125
                        success color: #ffffff, border-color: #2db933
                     */
                        $parentFormControl.find('.select2-choices').each(function (key, $ele) {
                            angular.element($ele).css({ 'border-color': borderColor });
                        });
                        $parentFormControl.find('.err-tip').each(function (key, $ele) {
                            angular.element($ele).css({ 'visibility': isError ? 'visible' : 'hidden' });
                        });
                        $parentFormControl.find('.success-tip').each(function (key, $ele) {
                            angular.element($ele).css({ 'visibility': isSuccess ? 'visible' : 'hidden' });
                        });
                    };
                    // catch input data on typing
                    angular.element(document).on('keypress', element, function (event) {
                        if (element.select2('isFocused') && _(select2Data()).isArray()) {
                            currentElement = $(event.target);
                            var inputData = select2Data();
                            $timeout(function () {
                                var typingData = currentElement.val();
                                if ($scope.settings.validation) {
                                    if ($scope.settings.validationType === 'ip' && !regexUtility.utilities.validationIPandSubnet(typingData) || $scope.settings.validationType === 'domain' && !regexUtility.utilities.validationDomain(typingData)) {
                                        changeBoxStyle('#cc4125', true, false);
                                    } else {
                                        changeBoxStyle('#2db933', false, true);
                                        if (event.which === 32) {
                                            inputData.push(typingData.trim());
                                            $scope.model = inputData;
                                            element.select2('data', inputData);
                                            changeBoxStyle('#cccccc', false, false);
                                        }
                                    }
                                }
                            });
                        }
                    });
                    // clearing on blur
                    angular.element(document).on('click', function (event) {
                        $timeout(function () {
                            changeBoxStyle('#cccccc', false, false);
                        });
                    });
                }
                function dynamicParams() {
                    if (!$scope.settings.lookup || !$scope.settings.lookup.dynamicParams) {
                        return {};
                    }
                    var dynParams = {};
                    _($scope.settings.lookup.dynamicParams).each(function (param, key) {
                        if ($scope.settings.lookup.refParams[param]) {
                            dynParams[key] = $scope.settings.lookup.refParams[param].data;
                        }
                    });
                    return dynParams;
                }
                function reinit() {
                    multiple = $scope.settings.multiple !== false;
                    var selectSettings = {
                        dropdownCssClass: 'hidden-list-selector-dropdown',
                        placeholder: $scope.settings.placeholder || 'Type and press enter',
                        selectOnBlur: true,
                        createSearchChoice: $scope.settings.createSearchChoice || defaultCreateSearchChoice,
                        multiple: multiple,
                        tokenSeparators: $scope.settings.tokenSeparators,
                        data: []
                    };
                    if (!_($scope.variants).isUndefined()) {
                        var data = _($scope.variants).chain();
                        if ($scope.settings.sortVariants) {
                            data = data.sortBy(function (variant) {
                                return variant.label || variant;
                            });
                        }
                        data = data.map(function (variant) {
                            if (variant.label) {
                                return {
                                    id: variant.id,
                                    text: variant.label
                                };
                            } else {
                                return variant;
                            }
                        }).value();
                        selectSettings = {
                            dropdownCssClass: 'list-selector-dropdown',
                            placeholder: 'Click to select',
                            multiple: multiple,
                            data: data,
                            allowClear: $scope.settings.allowClear
                        };
                        if ($scope.settings.allowCreate) {
                            selectSettings.createSearchChoice = $scope.settings.createSearchChoice || defaultCreateSearchChoice;
                            selectSettings.placeholder = 'Click to select or enter value';
                            selectSettings.formatNoMatches = false;
                        }
                    }
                    if ($scope.settings.lookup) {
                        selectSettings = {
                            dropdownCssClass: 'list-selector-dropdown',
                            placeholder: 'Click to select',
                            multiple: multiple,
                            query: function (options) {
                                var p = $q.when();
                                if ($scope.settings.lookup.preFetch && $scope.settings.lookup.preFetch.endpoint) {
                                    p = p.then(function () {
                                        return commonDao.genericLookup($scope.settings.lookup.preFetch.endpoint, {});
                                    });
                                }
                                p.then(function (res) {
                                    var requiredParamId = '';
                                    var generatedParams = $.extend({}, $scope.settings.lookup.params, $scope.lookupParams, dynamicParams(), { q: options.term });
                                    if ($scope.settings.lookup.preFetch && $scope.settings.lookup.preFetch.param) {
                                        requiredParamId = $scope.settings.lookup.preFetch.param;
                                        if (res && res.data && res.data[requiredParamId]) {
                                            var requiredParam = {};
                                            requiredParam[requiredParamId] = res.data[requiredParamId];
                                            generatedParams = $.extend(generatedParams, requiredParam);
                                        }
                                    }
                                    return commonDao.genericLookup($scope.settings.lookup.endpoint, generatedParams).pagination((options.page - 1) * recordsPerPage, recordsPerPage);
                                }).then(function (response) {
                                    options.callback({
                                        results: _(response.data.rows).map(function (row) {
                                            return {
                                                id: row.id,
                                                text: row.label
                                            };
                                        }),
                                        more: response.data.total_rows > options.page * recordsPerPage
                                    });
                                });
                            },
                            allowClear: $scope.settings.allowClear
                        };
                        if (_($scope.settings.lookup.minInput).isUndefined()) {
                            selectSettings.minimumInputLength = 2;
                        } else {
                            selectSettings.minimumInputLength = $scope.settings.lookup.minInput;
                        }
                        if (_($scope.settings.lookup.no_matches_text).isString()) {
                            selectSettings.formatNoMatches = $scope.settings.lookup.no_matches_text;
                        }
                        if (!$scope.settings.lookup.strict) {
                            selectSettings.placeholder = 'Type and press enter';
                            selectSettings.dropdownCssClass += ' search-field-always-visible';
                            selectSettings.selectOnBlur = true;
                            selectSettings.createSearchChoice = $scope.settings.createSearchChoice || defaultCreateSearchChoice;
                        }
                    }
                    if ($scope.settings.validationOnTyping) {
                        selectSettings.selectOnBlur = false;
                        selectSettings.closeOnSelect = false;
                        selectSettings.openOnEnter = false;
                    }
                    element.prop('readonly', !!$scope.selectDisabled);
                    if (initialized) {
                        element.select2('destroy');
                    }
                    initialized = false;
                    element.addClass('list-selector');
                    element.css('display', 'inline-block');
                    element.css('width', '100%');
                    element.find('.select2-choices').addClass('form-control');
                    element.select2(selectSettings);
                    initialized = true;
                    function findElement(id) {
                        if (_(id).isUndefined()) {
                            return;
                        }
                        if (_($scope.variants).isUndefined()) {
                            return {
                                id: id,
                                text: id
                            };
                        }
                        var found = false;
                        _(selectSettings.data).find(function (item) {
                            if (item.children) {
                                _(item.children).find(function (item) {
                                    if (item.id === id) {
                                        found = item;
                                    }
                                    return found;
                                });
                            }
                            if (item.id === id) {
                                found = item;
                            }
                            return found;
                        });
                        if (found !== false) {
                            return found;
                        }
                    }
                    if ($scope.settings.lookup) {
                        if ($scope.model && (!_($scope.model).isArray() || $scope.model.length)) {
                            element.select2('enable', false);
                            var ids = selectSettings.multiple ? $scope.model.join(',') : $scope.model;
                            var p = $q.when();
                            if ($scope.settings.lookup.preFetch && $scope.settings.lookup.preFetch.endpoint) {
                                p = p.then(function () {
                                    return commonDao.genericLookup($scope.settings.lookup.preFetch.endpoint, {});
                                });
                            }
                            p.then(function (res) {
                                var requiredParamId = '';
                                var generatedParams = $.extend({}, $scope.settings.lookup.params, dynamicParams(), { ids: ids });
                                if ($scope.settings.lookup.preFetch && $scope.settings.lookup.preFetch.param) {
                                    requiredParamId = $scope.settings.lookup.preFetch.param;
                                    if (res && res.data && res.data[requiredParamId]) {
                                        var requiredParam = {};
                                        requiredParam[requiredParamId] = res.data[requiredParamId];
                                        generatedParams = $.extend(generatedParams, requiredParam);
                                    }
                                }
                                return commonDao.genericLookup($scope.settings.lookup.endpoint, generatedParams);
                            }).then(function (response) {
                                var dataMap = {};
                                _(response.data.rows).each(function (row) {
                                    dataMap[row.id] = {
                                        id: row.id,
                                        text: row.label
                                    };
                                });
                                element.select2('enable', true);
                                if (selectSettings.multiple) {
                                    element.select2('data', _($scope.model).map(function (id) {
                                        return dataMap[id] || {
                                            id: id,
                                            text: id
                                        };
                                    }));
                                } else {
                                    element.select2('data', dataMap[$scope.model] || ($scope.settings.lookup.clearIfNotExists ? {
                                        id: '',
                                        text: ''
                                    } : {
                                        id: $scope.model,
                                        text: $scope.model
                                    }));
                                }
                            });
                        }
                    } else {
                        if (selectSettings.multiple) {
                            element.select2('data', _($scope.model).chain().map(findElement).filter(function (d) {
                                return _(d).isObject();
                            }).value());
                        } else {
                            element.select2('data', findElement($scope.model));
                        }
                    }
                    if (requiredFocus) {
                        element.select2('focus');
                        requiredFocus = false;
                    }
                }
                $scope.$watch('model', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        if (!initialized || !_(newVal).isEqual(select2Data())) {
                            reinit();
                        }
                    }
                }, true);
                $scope.$watch('variants', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        reinit();
                    }
                }, true);
                $scope.$watch('selectDisabled', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        reinit();
                    }
                });
                if ($scope.settings.lookup && $scope.settings.lookup.dynamicParams) {
                    $scope.$watch(function () {
                        return dynamicParams();
                    }, function (newVal, oldVal) {
                        if (!angular.equals(newVal, oldVal)) {
                            reinit();
                        }
                    }, true);
                }
                reinit();
                if ($scope.focusOnLoad) {
                    $timeout(function () {
                        element.select2('open');
                    }, 500);
                }
                $scope.$on('$destroy', function () {
                    element.select2('destroy');
                    initialized = false;
                });
            }
        };
    }]);
}());